import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { IndicatorsProvider as Provider, platformProviderValue } from '@shapeable/ui';

const INDICATORS_QUERY = graphql`
  query ThemeShapeableWeb_PlatformIndicatorsQuery {
    platform {
      allIndicators {
        id name slug title subtitle precision __typename
        description { text }
        color { id name slug value }
        layout { id name weight slug component __typename }
        links { id url name slug __typename }
        icon { id name slug component }
        type { id name slug }
        trends { id slug }
        topics { id slug }
        subTopics { id slug }
        challenges { id slug }
        unit { 
          id slug prefix shorthand suffix  __typename
          minValue maxValue numericMinValue numericMaxValue 
          valueType { id slug } 
        } 
        supportingIndicators { 
          id name slug title subtitle precision __typename
          layout { id name weight slug component __typename }
          description { text }
          color { id name slug value }
          links { id url name slug __typename }
          icon { id name slug component }
          type { id name slug }
          trends { id slug }
          topics { id slug }
          subTopics { id slug }
          challenges { id slug }
          description { text }
          unit { 
            id slug prefix shorthand suffix  __typename
            minValue maxValue numericMinValue numericMaxValue 
            valueType { id slug } 
          } 
        }
      }
    }
  }
`;

export const IndicatorsProvider: React.FC<any> = ({ children }) => {
  return <Provider value={ platformProviderValue( useStaticQuery(INDICATORS_QUERY), 'allIndicators' ) }>{children}</Provider>;
}